// Customizable Area Start
import React, { Component } from "react";
import Footer from "../../blocks/navigationmenu/src/Footer.web";

interface Props {
  navigation: any;
}

export default class AppFooter extends Component<Props> {
  render() {
    return <Footer navigation={this.props.navigation} />;
  }
}
// Customizable Area End
